import { formatRegionChipLabel, formatRegionTooltip } from './utils/formatRegion';
import styles from './blocks.module.css';

export default function RegionChip({ region, onClick }) {
    const label = formatRegionChipLabel(region);
    return (
        <button
            type="button"
            className={styles.regionChip}
            onClick={(e) => {
                e.stopPropagation();
                onClick?.(region);
            }}
            title={formatRegionTooltip(region)}
        >
            <span className={styles.regionChipLabel}>{label}</span>
        </button>
    );
}
